import api from '../utils/api';
import { logError } from '@zg-rentals/log-error';

// service

const AddressActions = {
  getRestrictions(addressData) {
    const { address, unit, listingTypeCode, listingAlias, propertyTypeCode } = addressData;
    return (dispatch) =>
      dispatch(
        api.properties.locations.getRestrictions({
          address,
          unit,
          listingTypeCode,
          listingAlias,
          propertyTypeCode,
        }),
      )
        .then((response) => {
          const { error: errorRMWModel, success } = response;

          if (success && response.response) {
            return response.response;
          }
          return Promise.reject(errorRMWModel);
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'AddressActions.getRestrictions',
          });
          return Promise.reject(errorRMWModel);
        });
  },
};

export default AddressActions;
